import { gql } from '@apollo/client';

export const UpdateSocialMediaServices = gql`
mutation UpdateSocialMediaServices($idStore: ID!, $content: contentSocialMedia!) {
  updateSocialMediaServices(idStore: $idStore, content: $content) {
    status
  }
}
`;